import { speechCommandsFR } from "./speechCommands_fr";

// load commands
const playerCommands = speechCommandsFR.player;

const player = '#JSGF V1.0; grammar player; public <player> = ' + playerCommands.join(' | ') + ';';

export const grammarFR = { player };